import * as angular from 'angular';
import { GradPlanningTransferStepperModule } from './grad-planning-transfer-stepper/grad-planning-transfer-stepper.module';
import { GradPlanningTransferTableModule } from './grad-planning-transfer-table/grad-planning-transfer-table.module';
import { GradPlanningWizardTransferComponent } from './grad-planning-wizard-transfer.component';

export const GradPlanningWizardTransferModule = angular
  .module('gradPlanningWizardTransfer', [GradPlanningTransferStepperModule, GradPlanningTransferTableModule])
  .component('gradPlanningWizardTransfer', GradPlanningWizardTransferComponent).name;
